var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOilTanks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77 96.0339H17V100H77V96.0339Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 62.9831H27.8C22.8294 62.9831 18.8 67.4223 18.8 72.8983V84.7966C18.8 90.2727 22.8294 94.7119 27.8 94.7119H65C69.9705 94.7119 74 90.2727 74 84.7966V72.8983C74 67.4223 69.9705 62.9831 65 62.9831Z",
    fill: "#F7931E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 61H29V62.9831H35V61Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1 62.9831V84.7966",
    stroke: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3 62.9831V84.7966",
    stroke: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4 71.2458H62",
    stroke: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4 75.8729H62",
    stroke: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4 79.839H62",
    stroke: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5434 78.2334C30.8041 77.3237 32.9022 73.5593 32.9022 73.5593C32.9022 73.5593 34.9942 77.3237 35.2609 78.2334C35.5276 79.1433 35.8677 80.6838 35.2609 81.8464C34.6551 83.0071 32.8992 82.7991 32.8992 82.7991C32.8992 82.7991 31.081 82.8423 30.5434 81.8464C29.9227 80.6967 30.2827 79.1433 30.5434 78.2334Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 35.0339H-1V39H59V35.0339Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 1.98305H9.79996C4.82939 1.98305 0.799957 6.42226 0.799957 11.8983V23.7966C0.799957 29.2727 4.82939 33.7119 9.79996 33.7119H47C51.9705 33.7119 56 29.2727 56 23.7966V11.8983C56 6.42226 51.9705 1.98305 47 1.98305Z",
    fill: "#F7931E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 0H11V1.98305H17V0Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1 1.98305V23.7966",
    stroke: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3 1.98305V23.7966",
    stroke: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4 10.2458H44",
    stroke: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4 14.8729H44",
    stroke: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4 18.839H44",
    stroke: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5434 17.2334C12.8041 16.3237 14.9022 12.5593 14.9022 12.5593C14.9022 12.5593 16.9942 16.3237 17.2609 17.2334C17.5276 18.1433 17.8677 19.6838 17.2609 20.8464C16.6551 22.0071 14.8992 21.7991 14.8992 21.7991C14.8992 21.7991 13.081 21.8423 12.5434 20.8464C11.9227 19.6967 12.2827 18.1433 12.5434 17.2334Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 64.0339H40V68H100V64.0339Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 30.9831H50.8C45.8294 30.9831 41.8 35.4223 41.8 40.8983V52.7966C41.8 58.2727 45.8294 62.7119 50.8 62.7119H88C92.9705 62.7119 97 58.2727 97 52.7966V40.8983C97 35.4223 92.9705 30.9831 88 30.9831Z",
    fill: "#F7931E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 29H52V30.9831H58V29Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1 30.9831V52.7966",
    stroke: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3 30.9831V52.7966",
    stroke: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4 39.2458H85",
    stroke: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4 43.8729H85",
    stroke: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4 47.839H85",
    stroke: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5434 46.2334C53.8041 45.3237 55.9022 41.5593 55.9022 41.5593C55.9022 41.5593 57.9942 45.3237 58.2609 46.2334C58.5276 47.1433 58.8677 48.6838 58.2609 49.8464C57.6551 51.0071 55.8992 50.7991 55.8992 50.7991C55.8992 50.7991 54.081 50.8423 53.5434 49.8464C52.9227 48.6967 53.2827 47.1433 53.5434 46.2334Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOilTanks);
export default __webpack_public_path__ + "static/media/OilTanks.6394ce989663ed7f774fbab4ddf06387.svg";
export { ForwardRef as ReactComponent };